import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import fondo from '../assets/edu.webp'; 
import Swal from "sweetalert2";
import '../styles/disenocalculadorasbase.css';
import '../styles/disenocalculadorasbase.css';

export default function CalculadoraEducacion() {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [edad, setEdad] = useState("");
  const [ingreso, setIngreso] = useState("");
  const [tiempo, setTiempo] = useState("");
  var [crecimiento] = useState("10.5");

  const handleSubmit = () => {
    if (!nombre || !edad || !ingreso || !tiempo) {
      Swal.fire({
        icon: "warning",
        title: "Campos incompletos",
        text: "Por favor, completa todos los campos.",
      });
      return;
    }

    if (isNaN(edad) || edad <= 0 || edad > 99) {
      Swal.fire({
        icon: "error",
        title: "Edad inválida",
        text: "Por favor, ingresa una edad válida entre 1 y 99.",
      });
      return;
    }

    if (isNaN(ingreso) || ingreso <= 0) {
      Swal.fire({
        icon: "error",
        title: "Ingreso inválido",
        text: "El ingreso debe ser un número mayor que cero.",
      });
      return;
    }
    if(edad >= 50){
      crecimiento = 8.5
    }
    navigate("/DisplayCalculo", {
      state: { nombre, edad, ingreso, tiempo, crecimiento }
    });
  };

  return (
    <>
      <button
        onClick={() => navigate('/')}
        className="calculadora-back"
      >
        ← Regresar al Menú
      </button>
      <div className="calculadora-container">
        <div 
          className="calculadora-left"
          style={{ backgroundImage: `url(${fondo})` }}
        >
          <div className="calculadora-overlay">
            <h1>Planifica tu educación o la de tu familia</h1>
            <p>
              La educación es una inversión valiosa. Calcula cuánto puedes acumular para estudios futuros y toma el control de tu preparación.
            </p>
          </div>
        </div>

        <div className="calculadora-form">
          <h2>Calculadora de Educación</h2>

          <label>Nombre:</label>
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />

          <label>Edad:</label>
          <input
            type="number"
            value={edad}
            onChange={(e) => {
              const valor = e.target.value;
              if (valor === "" || (Number(valor) >= 1 && Number(valor) <= 99)) {
                setEdad(valor);
              }
            }}
            min="1"
            max="99"
          />

          <label>Ingreso al fondo (mensualmente):</label>
          <input type="number" value={ingreso} onChange={(e) => setIngreso(e.target.value)} />

          <label>Tiempo (en años):</label>
          <select value={tiempo} onChange={(e) => setTiempo(e.target.value)}>
            <option value="">Selecciona un tiempo</option>
            {[...Array(25)].map((_, i) => (
              <option key={i + 1} value={i + 1}>{i + 1}</option>
            ))}
          </select>

          <button onClick={handleSubmit} className="calculadora-btn">Crear Cálculo</button>

          <p
            onClick={() => navigate("/pantallaCIT")}
            className="calculadora-link"
          >
            ¿Te parece si vemos más a fondo los planes de educación? Agenda tu cita aquí!
          </p>
        </div>
      </div>
    </>
  );
}


